export const customer = {
    etxHost: null,
    appTitle: 'Amplify Enrollment',
    customerShortName: 'Amplify',
    theme: 'amplify',
    guidTitle: 'GUID',
    userInactivityTimeout: 60 * 60 * 1000,
    restrictedInternalLoginRoles: ['INSTITUTIONAL_ADMIN', 'APPLICATION_ADMIN'],
    sftpHost: 'upload.enrollment.devci.amplify.com',
    features: {
        ssoApp: false,
        onboardingWizard: false,
        anyDataAnywhere: false
    }
};

export const customerProd = {
    sftpHost: 'upload.enrollment.amplify.com'
};
